<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import capitalize from 'lodash/capitalize'
import SupplierInformation from './tabs/supplier-information'
import SupplierContracts from './tabs/supplier-contracts'
import SupplierCatalogue from './tabs/supplier-catalogue'

export default {
  name: 'Supplier',
  page: {
    title: 'Supplier',
  },
  components: {
    SupplierInformation,
    SupplierContracts,
    SupplierCatalogue,
  },
  data() {
    return {
      loading: true,
      activeTab: '',
    }
  },
  computed: {
    ...mapState('suppliers', ['supplier']),
    ...mapGetters('me', [
      'canSearchSupplier',
      'canListContract',
      'canListAllSupplierProduct',
      'canUpdateSupplier',
      'canCreateSupplierProduct',
      'canDeleteSupplier',
    ]),
    id() {
      return this.$route.params.id || null
    },
    supplierName() {
      return this.supplier.name || 'Supplier'
    },
    tabs() {
      const tabs = []

      tabs.push({
        label: 'Information',
        name: 'information',
      })

      if (this.canListContract) {
        tabs.push({
          label: 'Contracts',
          name: 'contracts',
        })
      }

      if (this.canListAllSupplierProduct) {
        tabs.push({
          label: 'Supplier Catalogue',
          name: 'catalogue',
        })
      }

      return tabs
    },
    commands() {
      const dropdownItems = []

      if (this.canUpdateSupplier) {
        dropdownItems.push({
          label: 'Edit Supplier',
          name: 'supplier-edit',
        })
        dropdownItems.push({
          label: 'Update Status',
          name: 'supplier-status',
        })
      }

      if (this.canCreateSupplierProduct) {
        dropdownItems.push({
          label: 'Add Supplier Product',
          name: 'add-product',
        })
      }

      if (this.canDeleteSupplier) {
        dropdownItems.push({
          label: 'Delete Supplier',
          name: 'supplier-delete',
        })
      }

      return dropdownItems
    },
  },
  async created() {
    const [error] = await this.getSupplier(this.id)

    if (error) {
      this.getErrorMessage(error, 'Supplier', 'ID', this.id)
    }

    this.loading = false

    const { tab } = this.$route.params

    if (
      (!this.canListContract && tab === 'contracts') ||
      (!this.canListAllSupplierProduct && tab === 'catalogue')
    ) {
      this.activeTab = 'information'
      this.$router.replace({
        name: 'supplier-details',
        params: {
          id: this.id,
        },
      })
    } else {
      this.activeTab = tab || this.tabs[0].name
    }
  },
  methods: {
    capitalize,
    ...mapActions('suppliers', ['getSupplier']),
    onTabClick(newTab, prevTab) {
      if (newTab !== prevTab) {
        this.$router.push({
          name: 'supplier-details',
          params: {
            id: this.id,
            tab: newTab,
          },
        })
      }
    },
    onMenuSelect(name) {
      if (name === 'add-product') {
        this.$router.push({
          name: 'supplier-create-product',
          params: { supplierId: this.id },
        })
      } else {
        this.$modal.show(name, {
          props: {
            supplier: this.supplier,
            id: this.supplier.id,
          },
        })
      }
    },
  },
}
</script>

<template>
  <main-layout
    :title="supplierName"
    :back="canSearchSupplier && { name: 'suppliers' }"
    :loading="loading"
    :error-message="errorMessageText"
  >
    <el-dropdown
      v-if="commands && commands.length && !errorMessageText"
      slot="header"
      trigger="click"
      @command="onMenuSelect"
    >
      <dropdown-icon />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(command, index) in commands"
          :key="index"
          :command="command.name"
        >
          {{ command.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-tabs
      v-model="activeTab"
      :before-leave="onTabClick"
    >
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
        lazy
      >
        <component
          :is="`Supplier${capitalize(tab.name)}`"
          v-if="activeTab === tab.name"
          :loading="loading"
          :supplier="supplier"
        />
      </el-tab-pane>
    </el-tabs>
  </main-layout>
</template>

<style lang="scss" module>
.button {
  height: 2rem;

  :global {
    .el-icon--right {
      margin-left: 0.6rem;
    }
  }
}

.buttonIcon {
  transform: rotate(90deg);
}
</style>
